var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#00B071"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0237 8.60945C17.4149 8.99925 17.4161 9.63241 17.0263 10.0237L11.38 15.6911C11.1926 15.8792 10.9381 15.985 10.6725 15.9853C10.407 15.9855 10.1522 15.8801 9.96447 15.6924L7.13605 12.864C6.74552 12.4734 6.74552 11.8403 7.13605 11.4497C7.52657 11.0592 8.15974 11.0592 8.55026 11.4497L10.6703 13.5697L15.6095 8.61209C15.9993 8.22084 16.6324 8.21966 17.0237 8.60945Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/CheckIcon.d6f5d679d6fbf10af35b80031cdfb27e.svg";
export { ForwardRef as ReactComponent };